import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'mobx-react';
import { ConfigProvider, theme } from 'antd';
import { storesContext } from './store/index';
import App from './router/index';
import reportWebVitals from './reportWebVitals';
import locale from 'antd/locale/zh_CN';
import dayjs from 'dayjs';
import './assets/style/index.scss';

import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={{
    storesContext
  }}>
    <Suspense fallback={<div>加载中...</div>}>
      <ConfigProvider 
        locale={locale}
        theme={{
          // NOTE:sd 的萨芬领导
          // TODO:设置全局主题颜色
          // 1. 单独使用暗色算法
          // algorithm: theme.darkAlgorithm,
          // algorithm: [theme.darkAlgorithm, theme.compactAlgorithm],
          token: {
            // Seed Token，影响范围大
            colorPrimary: '#00b96b',
            borderRadius: 2,
            // 派生变量，影响范围小
            // colorBgContainer: '#f6ffed',
            // ==============================
          },
          components: {
            Button: {
              colorPrimary: '#00b96b',
              algorithm: true, // 启用算法
            },
            Card: {
              actionsBg: '#000',
              extraColor: 'red',
              headerHeight: 50,
              headerFontSize: 30
            },
            Menu: {
              // itemActiveBg: 'red',
              // itemBg: 'black',
              // itemHoverColor: '#00b96b',
              itemColor: '#333',
              // activeBarBorderWidth: 0
            }
          }
        }}>
        <App />
      </ConfigProvider>
    </Suspense>
  </Provider>
);

// React.StrictMode 会在dev环境重复执行render
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
